import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../../action';
import * as c from '../../constant';

function MiscFeeSettingsFeesContent({
  handleRemove,
  handleEdit,
  officeId,
  showMiscFeeSettingsOffice,
  miscFeeSettingsOfficeData,
}) {
  useEffect(() => {
    if (_.isEmpty(officeId)) return;
    showMiscFeeSettingsOffice(officeId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(officeId)) return;
    showMiscFeeSettingsOffice(officeId);
  }, [officeId]);
  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(miscFeeSettingsOfficeData) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="font-weight-bold text-uppercase">
                  {_.get(miscFeeSettingsOfficeData, 'attributes.name') || '--'}
                </h2>
                <div className="col-4 d-flex px-0 mx-0">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(miscFeeSettingsOfficeData)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(miscFeeSettingsOfficeData)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group">
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Office Name:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsOfficeData,
                                'attributes.name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Code:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsOfficeData,
                                'attributes.code'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Description:
                            </label>
                            <span className="full-input">
                              {_.get(
                                miscFeeSettingsOfficeData,
                                'attributes.description'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

MiscFeeSettingsFeesContent.propTypes = {
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showMiscFeeSettingsOffice: PropTypes.instanceOf(Function).isRequired,
  miscFeeSettingsOfficeData: PropTypes.instanceOf(Object).isRequired,
  officeId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  miscFeeSettingsOfficeData:
    _.get(api, `${c.SHOW_MISC_FEE_SETTINGS_OFFICE}.item`) || {},
  officeId: _.get(match, 'params.userManagementId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MiscFeeSettingsFeesContent);
